import React from 'react';
import {
  Table,
  TableWrapper,
  TableRow,
  TableCell,
  ChartTableWrapper,
} from './chartTable.style';
import ChartTableHeader from './tableHeader';
import TableBody from 'components/data-visualization/Table/Body';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';
import TableLoader from 'components/utility/ContentLoader/TableLoader/TableLoader';

const ChartTableLoader: React.FC<{ isLargeScreen: boolean }> = ({
  isLargeScreen,
}) => {
  return (
    <ChartTableWrapper>
      <ContentLoader width={480} height={116}>
        <rect width="225" height="32" x="0" y="4" />
        <rect width="480" height="19" x="0" y="46" />
        <rect width="115" height="23" x="0" y="78" />
      </ContentLoader>

      {isLargeScreen && (
        <TableWrapper>
          <Table>
            <ChartTableHeader isDaily={true} />
            <TableBody>
              <TableLoader
                columnCount={7}
                rowComponent={TableRow}
                cellComponent={TableCell}
              />
            </TableBody>
          </Table>
        </TableWrapper>
      )}
    </ChartTableWrapper>
  );
};

export default ChartTableLoader;
